/** Represents the controller props for a React Hook Form based form component. */
export const hookFormControllerProps = [
    'control',
    'defaultValue',
    'name',
    'rules',
    'shouldUnregister',
];
